import $config from './config';
import $del from './del';
import $get from './get';
import $post from './post';
import $remove from './remove';
import $removeGroup from './removeGroup';

export default {
  config: $config,
  del: $del,
  get: $get,
  post: $post,
  remove: $remove,
  removeGroup: $removeGroup,
  account: {
    current: params => import('./account/current').then(d => d.default(params)),
    login: params => import('./account/login').then(d => d.default(params)),
    logout: params => import('./account/logout').then(d => d.default(params)),
    office: params => import('./account/office').then(d => d.default(params)),
    recovery: params => import('./account/recovery').then(d => d.default(params)),
  },
  agreement: {
    list: params => import('./agreement/list').then(d => d.default(params)),
    set: params => import('./agreement/set').then(d => d.default(params)),
    typeDate: params => import('./agreement/typeDate').then(d => d.default(params)),
  },
  dashboard: {
    get: params => import('./dashboard/get').then(d => d.default(params)),
  },
  dictionary: {
    get: params => import('./dictionary/get').then(d => d.default(params)),
    list: params => import('./dictionary/list').then(d => d.default(params)),
    set: params => import('./dictionary/set').then(d => d.default(params)),
  },
  news: {
    list: params => import('./news/list').then(d => d.default(params)),
  },
  registration: {
    create: params => import('./registration/create').then(d => d.default(params)),
    status: params => import('./registration/status').then(d => d.default(params)),
  },
  tourist: {
    list: params => import('./tourist/list').then(d => d.default(params)),
  },
};
